import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {labelCropSelection} from "./LabelCropSelection";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


export default function CropSelection(props) {

    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const labelCrop = labelCropSelection.labelCrop[langPref];

    const handleChange = (event) => {
        props.switchWizardCropKey(event.target.value);
    };

    //NOTE: This isn't the full catalog.  It's only the "crops" tree.
    if (props.beagleCropCatalog === undefined) {
        return (
            <div>
                <CircularProgress/>
            </div>
        )
    }

    //Resort the catalog, by language preference.
    let sortedBeagleCropCatalog =
        props.beagleCropCatalog.sort((a, b) => (a.cropName[langPref] > b.cropName[langPref]) ? 1 : -1);


    return (

        <div>
            <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">{labelCrop}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.wizardCropKey}
                    onChange={handleChange}
                >

                    {sortedBeagleCropCatalog.map((x) => (
                        <MenuItem key={x.cropKey} value={x.cropKey}>{x.cropName[langPref]}</MenuItem>
                    ))}

                </Select>
            </FormControl>
        </div>
    );
}
